<template>
    <div class="CSChatThai" style="background: #2562af;">
     <div style="background: #2562af !important; padding: 10px;">

  <v-btn icon @click="goback()" style="margin: 0 !important;">
        <v-icon class="white--text" style="font-size: 24px;">chevron_left</v-icon>
      </v-btn>
 

 <span style="color: white;font-weight: 800; margin-left: 25vw;">เพิ่มเพื่อน</span>

</div>





<div class="createGroupStyle" @click="gotopath('/create_group')">
<v-layout row wrap>
  <v-flex xs2 xl2 lg2 md2 sm2>
      <v-avatar color="white"  size="40px">
        <v-icon color="#909090" style="font-size: 24px;">mdi-account-group</v-icon>
      </v-avatar>
    </v-flex>
    <v-flex xs9 xl9 lg9 md9 sm9>
      <p style="color:#4e4e4ec2;margin-bottom: 0 !important; margin-left: 10px; font-weight: 800 !important;">สร้างกลุ่ม</p>
      <span style="color:#909090c9;margin-bottom: 0 !important; margin-left: 10px;font-size: 12px;">สร้างกลุ่มสำหรับคุณและเพื่อน</span>
    </v-flex>
  </v-layout>
  </div>




<div style="padding: 10px; cursor: pointer;background: #fafafa;">
<v-layout row wrap>
  <v-flex xs12 xl12 lg12 md12 sm12>
      <v-text-field
              solo
              placeholder="ค้นหาเพื่อน"
              prepend-inner-icon="fas fa-search"
              hide-details
              height="35"
              v-model="searchText"
              @input="searchUser()"
            ></v-text-field>


    </v-flex>
      <v-flex xs12 xl12 lg12 md12 sm12>
<!-- 
    {{listUser}}


 -->
 <div v-if="stateSearch">
      <v-list two-line style="height: 60vh;overflow: scroll;margin-top: 10px;" v-if="listUser.length > 0">
    <template v-for="(item, index) in listUser" >

      <v-list-tile avatar @click="selectRoom_userOnline(item.username)">
        <v-list-tile-avatar color="#2562af" size="40">
            <span class="white--text headline" v-if="!item.profile_picture">
              {{(item['display_name'].length>=2)? item['display_name'].charAt(0)+item['display_name'].charAt(1):item['display_name'].charAt(0)}}</span>
            <img :src="backend + item.profile_picture" v-else />
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title class="CSChatThai" v-text="item['display_name']"></v-list-tile-title>
          <v-list-tile-sub-title class="CSChatThai" v-text="item['email']"></v-list-tile-sub-title>
        </v-list-tile-content>

      </v-list-tile>

      <v-divider v-if="index != listUser.length -1"></v-divider>
    </template>
  </v-list>
  <p v-else-if="searchText.length < 3" style="text-align: center;
    margin-top: 10px;">
    ต้องค้นหาตั้งแต่ 3 ตัวอักษรขึ้นไป
  </p>
  <p v-else style="text-align: center;
    margin-top: 10px;">
    ไม่พบเพื่อนที่ต้องการค้นหา
  </p>
</div>


  <p v-else style="text-align: center;
    margin-top: 10px;">
    ค้นหาเพื่อนของคุณ จากอีเมลหรือชื่อ
  </p>


  </v-flex>
    
  </v-layout>
  </div>






    </div>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Momenttime, Decode, Encode } from '@/services'

const SET_TIME_READ = gql`
mutation ($user_id: uuid!, $room_id: uuid!) {
  update_member(where: {room_id: {_eq: $room_id}, _and: {user_id: {_eq: $user_id}}}, _set: {time_read: "now()"}) {
    returning {
      time_read
      room_id
      member_id
    }
  }
}
`

export default {
  data: () => ({
    listRoom: [],
    user_id: '',
    listUserOnline: [],
    Authorization: {},
    searchText: '',
    backend: process.env.VUE_APP_API,
    listUser: [],
    stateSearch: false
  }),
  apollo: {
  },
  computed: {
    ...sync('*')
  },
  created () {
    // this.$session.set('user_id', Encode.encodeToken('eeb8855b-b330-4bc5-a1d1-e7f3c3350277'))
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}
  },
  methods: {
    selectRoom_userOnline(user_id) {
      var reqestBody = {
        "user_id": this.user_id,
        "username_friend": user_id
      }
      this.axios.post(process.env.VUE_APP_API + '/createRoomByEmail', reqestBody, this.Authorization).then((response) => {
        this.$router.push('/chat_room?id=' + response.data.data.room_id)
        this.setTimeRead(response.data.data.room_id)
      })
    },
    searchUser () {
      // console.log('searchUser')
      this.stateSearch = true
      if (this.searchText.length >= 3) {
        var reqestBody = { email: this.searchText, onemail_token: Decode.decodeToken(localStorage.getItem('onemail_token')) }
        this.axios.post(process.env.VUE_APP_API_v2 + '/searchFriend', reqestBody, this.Authorization).then((response) => {
          // console.log(response.data)
          this.listUser = response.data
          // this.$router.push('/chat_room?id=' + response.data.data.room_id)
          // this.setTimeRead(response.data.data.room_id)
        })
      } else if (this.searchText.length == 0) {
        this.stateSearch = false
      }
    },
    setTimeRead(room_id) {
      this.$apollo.mutate({
        mutation: SET_TIME_READ,
        variables: {
          user_id: this.user_id,
          room_id: room_id
        }
      })
    },
    gotopath (path) {
      this.$router.push(path)
    },
    goback () {
      this.$router.back()
    }
  }
    
} 
</script>
<style type="text/css" scoped>
.CSChatThai {
 /*font-family: 'CS ChatThaiUI' !important;*/
 word-wrap: break-word;
}
>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    /*background: white !important;
    border-radius: 10px !important;*/
    background: #3978c7 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
  font-size: 15px;
}
.colorAvatar {
  color: #2562af !important;
}
.timeListChat {
  color: #adadad;
  font-size: 10px;
}
>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
}

>>>.v-badge--bottom .v-badge__badge {
  /*bottom: -8px !important;*/
  border: #2562af 2px solid !important;
  bottom: -6px !important;
}
>>>.v-badge__badge {
  height: 14px !important;
  width: 14px !important;
  right: -16px !important;
}
>>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}
.v-text-field--box .v-input__slot, .v-text-field--solo .v-input__slot {
  height: 30px;
}
.defaultPicOnline {
  margin-right: 5px;
  cursor: pointer;
  background: white;
}

>>>.v-text-field--solo input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--solo>.v-input__control>.v-input__slot {
    /*background: white !important;
    border-radius: 10px !important;*/
    background: #f3f3f3 !important;
    border-radius: 38px !important;
}

>>>.v-input input:focus .v-text-field .v-input__prepend-inner {
  color: red;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none;
}
>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
}
>>>.v-input__icon .v-input__icon--prepend-inner .v-icon {
  font-size: 13px !important;
}
>>>.v-icon {
    font-size: inherit;
  }

  >>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}

.theme--light.v-list {
    background: #fafafa;
    color: rgba(0,0,0,.87);
}
.createGroupStyle {
  background: #f3f3f3;padding: 10px; cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/mail/Addfriend.vue